import React, { Fragment } from "react";
import makeStyles from "@mui/styles/makeStyles";
import MediaDialog from "../../common/MediaDialog";
import Button from "@mui/material/Button";

const useStyles = makeStyles(theme => ({
  title: {
    textAlign: "center",
    fontSize: "2.2rem",
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.brandPrimary,
    paddingTop: "32px",
  },

  actions: {
    height: "120px",
    alignItems: "flex-start",
    justifyContent: "center",
  },

  btn: {
    width: "auto",
  },

  cancel: {
    color: theme.palette.secondary.contrastText,
    border: `2px solid ${theme.palette.secondary.contrastText}`,
  },
}));

// [Tyler] -- saving this for now. we could potentially manage status on a per org/sub basis
// const OrgSelect = ({ action, module, setOrgId }) => {
//   const subs = useSubscriptions(
//     null,
//     module.id,
//     true,
//     true,
//     false,
//     null,
//     null,
//     "subscription.endDate asc",
//     0,
//     "all",
//   );
//   console.log(subs);
//   return (
//     <Fragment>
//       From which organization would you like to {action} this module?
//       {subs.isSuccess && (
//         <OrganizationAutoComplete
//           required
//           onChange={setOrgId}
//           filterFunction={org => {
//             // only return orgs found from subs response if unpublishing
//             return action === "publish"
//               ? true
//               : includes(
//                   org.organizationId,
//                   pluck("organizationId", subs.data),
//                 );
//           }}
//         />
//       )}
//     </Fragment>
//   );
// };

const PublishStatusDialog = props => {
  const classes = useStyles();
  const { open, action, handleClickClose, handleStatusChange } = props;

  return (
    <MediaDialog
      open={open}
      contentClassName={classes.title}
      // content={
      //   isAdmin ? (
      //     <OrgSelect
      //       module={module}
      //       action={action}
      //       orgId={orgId}
      //       setOrgId={setOrgId}
      //     />
      //   ) : (
      //     `Are you sure you want to ${action} this module?`
      //   )
      // }
      content={`Are you sure you want to ${action} this module?`}
      handleClose={handleClickClose}
      actionsClassName={classes.actions}
      actions={
        <Fragment>
          <Button
            className={classes.cancel}
            classes={{ root: classes.btn }}
            variant="outlined"
            onClick={handleClickClose}
          >
            No, cancel
          </Button>
          <Button
            classes={{ root: classes.btn }}
            variant="contained"
            onClick={handleStatusChange}
          >
            Yes, {action}
          </Button>
        </Fragment>
      }
    />
  );
};

export default PublishStatusDialog;
